<template>
    <div class="element HiddenField hidden">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <input
            type="text"
            readonly
            autocomplete="false"
            :id="`field_${this.id}`"
            :name="this.name"
            v-model="input"
        />
    </div>
</template>

<script>
import {ref, watch} from "vue";

// Our form helpers
import { propDefaults } from "./_props";

// Our helpers
import { mergeDeep } from "helpers/_objects";

import { resolveProps } from "formbuilder/fields/_props";
import labelElement from "formbuilder/elements/LabelElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement
    },
    setup(props) {
        let input = ref("");
        watch(
            () => props.value,
            () => {
                input.value = props.value;
            },
            {
                immediate: true
            }
        );

        return {
            resolveProps,
            input
        };
    },
}
</script>